import { render, staticRenderFns } from "./FreeRequests.vue?vue&type=template&id=d9b1985c&scoped=true&"
import script from "./FreeRequests.vue?vue&type=script&lang=js&"
export * from "./FreeRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b1985c",
  null
  
)

export default component.exports